/**
 * Criteria of the "Plausibilitätsprüfung" that is executed as part of the
 * Indikatorenprüfung. AK_5 - AK_17 are evaluated per resident, AK_TOTAL is the
 * aggregated statistical control over the whole review population.
 *
 * AK_1 - AK_4 ("Übernahme vorheriger Ergebnisse") are suspended and therefore
 * not part of the check.
 */
export enum AkCriterion {
  AK_TOTAL = 'AK_TOTAL',
  AK_5 = 'AK_5',
  AK_6 = 'AK_6',
  AK_7 = 'AK_7',
  AK_8 = 'AK_8',
  AK_9 = 'AK_9',
  AK_10 = 'AK_10',
  AK_11 = 'AK_11',
  AK_12 = 'AK_12',
  AK_13 = 'AK_13',
  AK_14 = 'AK_14',
  AK_15 = 'AK_15',
  AK_16 = 'AK_16',
  AK_17 = 'AK_17',
}

/**
 * Order in which plausibility conflicts are returned: AK_TOTAL first (it
 * summarises the whole review), afterwards ascending AK number.
 */
export const AK_CRITERION_ORDER: readonly AkCriterion[] = [
  AkCriterion.AK_TOTAL,
  AkCriterion.AK_5,
  AkCriterion.AK_6,
  AkCriterion.AK_7,
  AkCriterion.AK_8,
  AkCriterion.AK_9,
  AkCriterion.AK_10,
  AkCriterion.AK_11,
  AkCriterion.AK_12,
  AkCriterion.AK_13,
  AkCriterion.AK_14,
  AkCriterion.AK_15,
  AkCriterion.AK_16,
  AkCriterion.AK_17,
];

/**
 * A single plausibility conflict. The backend only returns identifiers and
 * numbers, the user facing text is resolved via language keys on the frontend.
 */
export interface IPlausibilityConflict {
  /**
   * The AK criterion that was violated.
   */
  criterion: AkCriterion;
  /**
   * Resident the conflict belongs to, `null` for the aggregated AK_TOTAL result.
   */
  residentId: string | null;
  /**
   * AK_TOTAL only: residents with at least one AK 5 - 17 conflict.
   */
  affectedResidents: number | null;
  /**
   * AK_TOTAL only: residents included in the current indicator review.
   */
  totalResidents: number | null;
}
